import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

// Rtl
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [rtlPlugin],
});

const theme = createTheme({
  direction: "rtl",
  palette: {
    type: "light",
    primary: {
      main: "#1c4870",
    },
    secondary: {
      main: "#ef4c5b",
    },
    error: {
      main: "#f44336",
    },
  },
  typography: {
    fontFamily: "yekan",
    fontSize: 14,
  },
});

const MuiTheme = ({ children, ...rest }) => {
  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme} {...rest}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
};

export default MuiTheme;
